import { Reveal, MaskedLines } from "@/components/Reveal";

export default function PageHero({ overline, titleLines = [], description }) {
  return (
    <section className="relative overflow-hidden bg-navy pb-16 pt-32 md:pb-24 md:pt-44" data-testid="page-hero">
      <div className="grain absolute inset-0" />
      <div className="pointer-events-none absolute -right-20 top-10 select-none text-[22vw] font-black leading-none text-white/[0.04]">H</div>
      <div className="relative z-10 mx-auto max-w-7xl px-6 md:px-12">
        {overline && (
          <Reveal>
            <p className="mb-4 text-xs font-bold uppercase tracking-[0.25em] text-silver">{overline}</p>
          </Reveal>
        )}
        <h1 className="text-5xl font-black tracking-tighter text-white md:text-7xl">
          <MaskedLines lines={titleLines} lineClass="pb-1" />
        </h1>
        {description && (
          <Reveal delay={0.25}>
            <p className="mt-6 max-w-2xl text-lg leading-relaxed text-silver">{description}</p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
